import { render } from "./SoldEnergyCSV.vue?vue&type=template&id=485d2068&scoped=true&ts=true"
import script from "./SoldEnergyCSV.vue?vue&type=script&lang=ts"
export * from "./SoldEnergyCSV.vue?vue&type=script&lang=ts"

import "./SoldEnergyCSV.vue?vue&type=style&index=0&id=485d2068&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485d2068"]])

export default __exports__